export default "__VITE_ASSET__6a1146c7__"